import { Injectable } from "@angular/core";
import { User, UserManager } from "oidc-client";
import { AuthoritySettings } from "../models/AuthoritySettings";

@Injectable()
export class OidcClientService {
  userManager: UserManager;

  initUserManager(settings: AuthoritySettings) {
    const oidcSettings = {
      authority: settings.authority,
      client_id: settings.clientId,
      loadUserInfo: settings.loadUserInfo,
      redirect_uri: settings.redirectUri,
      silent_redirect_uri: settings.silentRedirectUri,
      automaticSilentRenew: settings.automaticSilentRenew,
      post_logout_redirect_uri: settings.postLogoutUri,
      response_type: settings.responseType,
      scope: settings.scope
    };
    this.userManager = new UserManager(oidcSettings);
  }

  public getUser(): Promise<User> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
